import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VuexORM from '@vuex-orm/core'
import VuexORMAxios from '@vuex-orm/plugin-axios'

import auth from './modules/auth'
import websocket from './modules/websocket'

import User from '@/models/User'
import Trace from '@/models/Trace'
import LiveTrace from '@/models/LiveTrace'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

// ORM
// Use Vuex ORM Axios
VuexORM.use(VuexORMAxios, { axios })
// Create a new instance of Database.
const database = new VuexORM.Database()

// Register Models to Database.
database.register(User)
database.register(Trace)
database.register(LiveTrace)

// Create Vuex Store and register database through Vuex ORM.
export default new Vuex.Store({
  state: {
  },
  getters: {
    me: state => {
      return {
        user_id: state.auth.id,
        short_name: state.auth.short_name,
        channel_name: state.websocket.channelName
      }
    }
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth,
    websocket
  },
  plugins: [VuexORM.install(database)],
  strict: debug
})
